<template>
  <div :style="{minHeight: minHeight + 'px'}">
    <slot name="contantView"></slot>
  </div>
</template>

<script>
// @ is an alias to /src
/*
  toName: 在isAlive为true时，toName为跳转路由name是缓存from页面
  fromName: from页面
*/
export default {
  name: 'baseView',
  props: {

  },
  components: {

  },

  data () {
    return {
      minHeight: document.documentElement.clientHeight
    }
  },
  watch: {

  },
  computed: {

  },
  methods: {

  },
  created () {

  }
}
</script>
<style scoped lang="scss">

</style>
